/*
 * This file contains a pagination component that allows users to navigate through a list of items.
 */

import React from "react";
import styles from "./pagination.module.scss";
import arrowRight from "../../assets/images/arrow-right.svg";
const Pagination = ({ currentPage = 1, totalPages = 1, onPageChange }) => {
  const validCurrentPage = isNaN(currentPage) ? 1 : currentPage;
  const validTotalPages = isNaN(totalPages) ? 1 : totalPages;

  const scrollToResultsCount = () => {
    if (typeof window === "undefined") return;
    const target = document.querySelector('[class*="ResultsCount"]');
    if (target && typeof target.scrollIntoView === "function") {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  if (validTotalPages <= 1) return;

  const handlePageClick = (page) => {
    if (page !== validCurrentPage) {
      onPageChange(page);
      scrollToResultsCount();
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];

    if (validTotalPages <= 4) {
      for (let i = 1; i <= validTotalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      if (validCurrentPage > 3) {
        pageNumbers.push("...");
      }

      const start = Math.max(2, validCurrentPage - 1);
      const end = Math.min(validTotalPages - 1, validCurrentPage + 1);

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      if (validCurrentPage < validTotalPages - 2) {
        pageNumbers.push("...");
      }

      if (!pageNumbers.includes(validTotalPages)) {
        pageNumbers.push(validTotalPages);
      }
    }

    return pageNumbers.map((page, index) =>
      page === "..." ? (
        <span key={`ellipsis-${index}`} className={styles.dots}>
          ...
        </span>
      ) : (
        <span
          key={page}
          className={`${styles.pageNumber} ${
            page === validCurrentPage ? styles.active : ""
          }`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </span>
      )
    );
  };

  return (
    <div className={styles.pagination}>
      <span
        className={`${styles.arrow} ${
          validCurrentPage === 1 ? styles.disabled : ""
        }`}
        onClick={() => {
          if (validCurrentPage > 1) {
            onPageChange(validCurrentPage - 1);
            scrollToResultsCount();
          }
        }}
      >
        <img src={arrowRight} className={styles.arrowLeft} alt="arrow right" />
      </span>

      {renderPageNumbers()}

      <span
        className={`${styles.arrow} ${
          validCurrentPage === validTotalPages ? styles.disabled : ""
        }`}
        onClick={() => {
          if (validCurrentPage < validTotalPages) {
            onPageChange(validCurrentPage + 1);
            scrollToResultsCount();
          }
        }}
      >
        <img src={arrowRight} className={styles.arrowRight} alt="arrow right" />
      </span>
    </div>
  );
};

export default Pagination;
